import React from "react";
import { X } from "lucide-react";

// Lightweight, reusable read-only details modal used by list pages for their
// "View" / "View Details" / "View Profile" row actions.
//   fields: array of { label, value } (falsy values are skipped)
export default function DetailModal({ open, title, subtitle, fields = [], onClose }) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-xl shadow-2xl w-full max-w-lg overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between p-6 border-b border-gray-100">
          <div>
            <h2 className="text-xl font-bold text-gray-900">{title}</h2>
            {subtitle && <p className="text-sm text-gray-500 mt-0.5">{subtitle}</p>}
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-700"
            aria-label="Close"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-6 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4">
          {fields
            .filter((f) => f && f.value !== undefined && f.value !== null && f.value !== "")
            .map((f) => (
              <div key={f.label}>
                <p className="text-xs font-semibold uppercase tracking-wide text-gray-400 mb-1">
                  {f.label}
                </p>
                <p className="text-sm text-gray-900 break-words">{String(f.value)}</p>
              </div>
            ))}
        </div>

        <div className="flex justify-end p-4 border-t border-gray-100">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-semibold text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
